export default "__VITE_ASSET__Cgm$Qvo$__"